var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-settings req-temp-container mt-6 md:mt-8 lg:mt-12"},_vm._l((_vm.settings),function(item){return _c('div',{key:item.title},[_c('link-card',{staticClass:"card-style",attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }